{
    "Branding_Labels_BrandingEnabled": "Activer la marque pour ce CME ?",
    "Branding_Tab_Name_Colours": "Couleurs",
    "Branding_Tab_Name_AdditionalColours": "Autres couleurs",
    "Branding_Tab_Name_Imagery": "Imagerie",
    "Branding_Tab_Name_Languages": "Langue",
    "Branding_Tab_Name_SSOButtons": "Boutons SSO",
    "Branding_Tab_Name_Links": "Links",
    "Branding_Labels_DarkMode": "(Mode sombre)",
    "Branding_Subtitles_ColourPalette": "Palette de couleurs",
    "Branding_Labels_PrimaryColour": "Primaire",
    "Branding_Labels_SecondaryColour": "Secondaire",
    "Branding_Labels_TertiaryColour": "Tertiaire",
    "Branding_Subtitles_HeaderSidebarColours": "Couleurs de l'en-tête\/de la barre latérale",
    "Branding_Labels_HeaderSidebarBackgroundColour": "Arrière-plan de l'en-tête\/de la barre latérale",
    "Branding_Labels_HeaderSidebarBackgroundContrastColour": "Accent sur l'en-tête\/la barre latérale",
    "Branding_Labels_HeaderSidebarIconColour": "Icônes d'en-tête\/barre latérale",
    "Branding_Subtitles_RouterColours": "Couleurs du routeur",
    "Branding_Labels_RouterLoaderBackgroundColour": "Contexte du chargeur de routeur",
    "Branding_Labels_RouterLoaderForegroundColour": "Chargeur de routeur au premier plan",
    "Branding_Subtitles_DashboardColours": "Couleurs du tableau de bord",
    "Branding_Labels_Dashboard_1_BgColour": "Contexte du tableau de bord 1",
    "Branding_Labels_Dashboard_1_FgColour": "Tableau de bord 1 Premier plan",
    "Branding_Labels_Dashboard_2_BgColour": "Contexte du tableau de bord 2",
    "Branding_Labels_Dashboard_2_FgColour": "Tableau de bord 2 Premier plan",
    "Branding_Labels_Dashboard_3_BgColour": "Contexte du tableau de bord 3",
    "Branding_Labels_Dashboard_3_FgColour": "Tableau de bord 3 Premier plan",
    "Branding_Labels_Dashboard_4_BgColour": "Contexte du tableau de bord 4",
    "Branding_Labels_Dashboard_4_FgColour": "Tableau de bord 4 Premier plan",
    "Branding_Labels_Dashboard_5_BgColour": "Contexte du tableau de bord 5",
    "Branding_Labels_Dashboard_5_FgColour": "Tableau de bord 5 Premier plan",
    "Branding_Labels_Dashboard_6_BgColour": "Contexte du tableau de bord 6",
    "Branding_Labels_Dashboard_6_FgColour": "Tableau de bord 6 Premier plan",
    "Branding_Subtitles_AuthColours": "Couleurs d'autorisation",
    "Branding_Labels_Auth_Subtitle_HighlightColour": "Couleur de surbrillance de l'autorisation",
    "Branding_Subtitles_InsightsColours": "Aperçus Couleurs",
    "Branding_Labels_Insights_Stat_1_Colour": "Statistiques d'information 1",
    "Branding_Labels_Insights_Stat_2_Colour": "Statistiques Insights 2",
    "Branding_Labels_Insights_Stat_3_Colour": "Statistiques Insights 3",
    "Branding_Labels_Insights_Stat_4_Colour": "Statistiques Insights 4",
    "Branding_Labels_Insights_Stat_5_Colour": "Statistiques Insights 5",
    "Branding_Labels_Insights_Percentage_Increase": "Indicateur de changement - Amélioration",
    "Branding_Labels_Insights_Percentage_Decrease": "Indicateur de changement - Déclin",
    "Branding_Labels_Insights_Percentage_NoChange": "Indicateur d'absence de changement",
    "Branding_Labels_Insights_Quick_BusiestDay": "Aperçu de la journée la plus chargée",
    "Branding_Labels_Insights_Quick_BusiestTime": "Aperçu de la période la plus chargée",
    "Branding_Labels_Highlights_MostCalled": "Faits saillants les plus appelés",
    "Branding_Labels_Highlights_MostAnsweredCalls": "Faits saillants Appels les plus répondus",
    "Branding_Subtitles_CompanyLogos": "Logos d'entreprise",
    "Branding_Labels_Imagery_MainLogo": "Logo principal (pour fond sombre)",
    "Branding_Labels_Imagery_MainLogo_White": "Logo principal (pour fond blanc)",
    "Branding_Labels_Imagery_Favicon": "Favicon (fichier .ico)",
    "Branding_Labels_Imagery_SquareLogo": "Logo carré",
    "Branding_Labels_Imagery_BroadworksLogo": "Logo de Broadworks",
    "Branding_Subtitles_Authorisation": "Images d'autorisation",
    "Branding_Labels_Imagery_AuthBg": "Contexte d'autorisation (image ou vidéo)",
    "Branding_Subtitle_AuthLanguages": "Page de connexion",
    "Branding_Labels_AuthTitle": "Sous-titre de la page de connexion",
    "Branding_Labels_AuthTitle2": "Page de connexion, sous-titre, ligne 2",
    "Branding_Subtitle_Broadworks": "Broadworks",
    "Branding_Labels_BroadworksName": "Nom de Broadworks",
    "Branding_Subtitle_SSOButtons": "Boutons SSO",
    "Branding_Labels_SSOIcon": "Icône",
    "Branding_Labels_SSOLabel": "Étiquette",
    "Branding_Labels_SSOUrl": "URL",
    "Branding_Labels_MainSiteLink": "Lien vers le site principal",
    "Branding_Validation_MustBeValidURL": "Doit être une URL valide",
    "Branding_SSO_Buttons_Add": "Ajouter un bouton SSO",
    "Branding_SSO_Buttons_Remove": "Supprimer le bouton SSO",
    "Branding_Labels_VanityURL": "URL",
    "Branding_ResetButton": "Réinitialiser à la version précédente",
    "Branding_RestoreCurrentVersion": "Retour à la version actuelle",
    "Branding_ApplyPreviewButton": "Cliquez pour prévisualiser",
    "Branding_PreviewButton": "Une version préliminaire est disponible. Cliquez pour prévisualiser.",
    "Branding_DeletePreview": "Supprimer l'aperçu",
    "Branding_UndoChanges": "Effacer les modifications actuelles",
    "Branding_Required_Message": "Ce champ est obligatoire",
    "Branding_Submission_Line1": "Nous générons votre image de marque pour vous",
    "Branding_Submission_Line2": "Cela peut prendre quelques secondes",
    "Branding_Validation_MaxWordLength": "Aucun mot ne doit dépasser {} caractères",
    "Branding_Validation_MaxLength": "Ne doit pas dépasser {} caractères",
    "NAME": "BrandingLanguage"
}